"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OmniFloater = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const ui_1 = require("@jsonjoy.com/ui");
const ContextMenu_1 = require("@jsonjoy.com/ui/lib/4-card/ContextMenu/ContextMenu");
const PositionAtPoint_1 = require("@jsonjoy.com/ui/lib/utils/popup/PositionAtPoint");
const useClickAway_1 = require("@jsonjoy.com/ui/lib/hooks/useClickAway");
const context_1 = require("../context");
exports.OmniFloater = ui_1.isTouch
    ? () => null
    : () => {
        const mutxt = (0, context_1.useMuTxt)();
        const omni = mutxt.omni;
        const open = omni.open.use();
        const point = omni.point.use();
        const mode = omni.mode.use();
        const clickAwayRef = (0, useClickAway_1.useClickAway)(React.useCallback(() => omni.close(), [omni]));
        React.useEffect(() => {
            if (!open)
                return;
            const close = () => omni.close();
            const unsubScroll = mutxt.scroll.scrollTop$.subscribe(close);
            const unsubWnd = mutxt.wnd.subscribe(close);
            return () => {
                unsubScroll();
                unsubWnd();
            };
        }, [open, mutxt, omni]);
        if (!open || !point)
            return null;
        const menu = omni.menu.build();
        const minWidth = mode === 'palette' ? 480 : 320;
        return (React.createElement(PositionAtPoint_1.PositionAtPoint, { point: point, animate: true },
            React.createElement("div", { ref: clickAwayRef, onMouseDown: (e) => {
                    if (e.target.tagName !== 'INPUT')
                        e.preventDefault();
                    e.stopPropagation();
                } },
                React.createElement(ContextMenu_1.ContextMenu, { inset: true, showSearch: true, menu: { ...menu, minWidth }, onEsc: omni.close, onClose: omni.close }))));
    };
